@if (!(form.get('detailCharacteristics.netSettlementGroup')?.disabled &&
  form.get('detailCharacteristics.connectionType')?.disabled &&
  form.get('detailCharacteristics.assetType')?.disabled &&
  form.get('detailCharacteristics.capacity')?.disabled &&
  form.get('detailCharacteristics.powerPlantIdentification')?.disabled)
  ) {
  <form [formGroup]="form">
    <app-guide-card
      [fullWidth]="fullWidth"
      [valid]="(form.get('detailCharacteristics.netSettlementGroup')?.valid || form.get('detailCharacteristics.netSettlementGroup')?.disabled) &&
      ((form.get('detailCharacteristics.connectionType')?.valid || form.get('detailCharacteristics.connectionType')?.disabled) &&
      (form.get('detailCharacteristics.assetType')?.valid || form.get('detailCharacteristics.assetType')?.disabled) &&
      (form.get('detailCharacteristics.capacity')?.valid || form.get('detailCharacteristics.capacity')?.disabled) &&
      (form.get('detailCharacteristics.powerPlantIdentification')?.valid || form.get('detailCharacteristics.powerPlantIdentification')?.disabled))">
      <div title>
        {{ 'meteringPoint.create.ownProduction.title' | translate }}
      </div>
      <div description>
        {{ 'meteringPoint.create.ownProduction.description' | translate }}
      </div>
      <div>
        <fieldset formGroupName="detailCharacteristics">
          <app-input-group [hideDisabled]="true">
            <label appLabel>{{ 'meteringPoint.create.netSettlementGroup' | translate }}</label>
            <select appSelect [collection]="netSettlementGroupList" formControlName="netSettlementGroup"></select>
          </app-input-group>

          <div class="bg-slate-100 dark:bg-dark-border w-full h-[1px] mt-6 mb-4"></div>

          <app-input-group [hideDisabled]="true">
            <label appLabel>{{ 'meteringPoint.create.connectionType' | translate }}</label>
            <select appSelect [collection]="connectionTypeList" formControlName="connectionType"></select>
          </app-input-group>

          <app-input-group [hideDisabled]="true">
            <label appLabel>{{ 'meteringPoint.create.assetType' | translate }}</label>
            <select appSelect [collection]="assetTypeList" formControlName="assetType"></select>
          </app-input-group>

          <app-input-group [hideDisabled]="true">
            <label appLabel>{{ 'meteringPoint.create.capacity' | translate }}</label>
            <input appInput formControlName="capacity" type="number" append="kW" [placeholder]="'meteringPoint.create.capacity' | translate">
          </app-input-group>

          <app-input-group [hideDisabled]="true">
            <label appLabel>{{ 'meteringPoint.create.powerPlantIdentification' | translate }}</label>
            <input appInput formControlName="powerPlantIdentification" [placeholder]="'meteringPoint.create.powerPlantIdentification' | translate">
          </app-input-group>
        </fieldset>
      </div>
    </app-guide-card>
  </form>
}
